import { NAVIGATION_ITEM_TYPE } from 'constants/navigation';
import { PAGE_CODES } from 'constants/pageCodes';

import { SystemPaths } from './routesConfig/system';

export const postClosingOptionsNavItems = [
  {
    id: 'min-deactivation-types',
    title: 'MIN Deactivation Types',
    type: NAVIGATION_ITEM_TYPE.ITEM,
    url: SystemPaths.minDeactivationTypes.path,
    exact: true,
    pageCode: PAGE_CODES.MIN_DEACTIVATION_TYPES,
  },
  {
    id: 'unsalable-responsible-parties',
    title: 'Unsalable Responsible Parties',
    type: NAVIGATION_ITEM_TYPE.ITEM,
    url: SystemPaths.unsalableResponsibleParties.path,
    exact: true,
    pageCode: PAGE_CODES.UNSALABLE_RESPONSIBLE_PARTIES,
  },
  {
    id: 'unsalable-reasons',
    title: 'Unsalable Reasons',
    type: NAVIGATION_ITEM_TYPE.ITEM,
    url: SystemPaths.unsalableReasons.path,
    exact: true,
    pageCode: PAGE_CODES.UNSALABLE_REASONS,
  },
];
